export const black = '#000000';
export const white = '#FFFFFF';
export const transparent = 'rgba(0,0,0, 0)';
export const blue = {
    100: '#E3EEFF',
    300: '#84A8F8',
    500: '#5C88DA',
    700: '#396AC7',
    900: '#25448C',
};
/**
 * May be deprecated, check with your designer for the correct color to use
 */
export const green = {
    100: '#E6F3EE',
    500: '#A3EA3F',
    700: '#00A878',
    800: '#027854',
};
/**
 * Neutral grey colors
 */
export const grey = {
    0: white,
    50: '#F7F7F7',
    100: '#F3F3F3',
    200: '#E8E8E8',
    300: '#D1D1D1',
    400: '#BBBBBB',
    500: '#8B8B8B',
    600: '#717171',
    700: '#5A5A5A',
    800: '#444444',
    900: '#272727',
    1000: black,
};
/**
 * Grey colors with a warm undertone
 */
export const warmGrey = {
    0: white,
    50: '#FAF7F7',
    100: '#F7F2F2',
    200: '#E8E0E0',
    300: '#DBD1D1',
    400: '#BDB3B3',
    500: '#A29999',
    600: '#7F7474',
    700: '#5B5555',
    800: '#443D3D',
    900: '#282424',
    1000: black,
};
/** May be remapped to neutral grey */
export const latte = {
    50: '#FBF3EC',
    100: '#FFF1EB',
};
export const lavender = {
    100: '#E8EAFC',
};
export const navy = {
    200: '#8EBBF4',
    400: '#6897D3',
    600: '#4F74A5',
    700: '#2D5680',
    800: '#203D5B',
    900: '#172C42',
};
export const purple = {
    100: '#F5E8FD',
};
export const red = {
    100: '#FFE7E9',
    200: '#FFCDCF',
    400: '#FFA3A6',
    500: '#FF7276',
    600: '#C55150',
    800: '#B8282A',
};
export const yellow = {
    100: '#FFF5BA',
    200: '#FFE2A1',
    300: '#FFD574',
    500: '#FFC845',
    600: '#F8B71E',
    800: '#DC6F08',
};
export const teal = {
    100: '#DDF5F5',
    200: '#7BFAF5',
    300: '#68E2DB',
    500: '#00BAB3',
    600: '#39827F',
    800: '#086360',
};
export const sand = {
    100: '#FBF2EB',
    200: '#F8E2D3',
    500: '#CDB5A7',
    600: '#A08B7E',
    700: '#776355',
    800: '#513F32',
};
/**
 * @deprecated use red palette instead, these colors map to their red equivalents
 */
export const pink = {
    /** Remapped to red 100 */
    100: red[100],
    /** Remapped to red 500 */
    500: red[500],
};
//# sourceMappingURL=data:application/json;base64,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